import React from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import { HardHat, TrendingUp } from "lucide-react";
import { motion } from "framer-motion";

const OccupationsTable = ({ data }) => {
    if (!data || data.length === 0) return null;

    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="bg-white p-6 rounded-3xl shadow-sm border border-gray-100 mt-12 overflow-hidden"
        >
            <div className="d-flex align-items-center gap-2 mb-6">
                <div className="p-2 bg-yellow-50 rounded-lg text-yellow-600">
                    <HardHat size={20} />
                </div>
                <h3 className="text-lg font-bold text-gray-800 m-0">Utah Construction Workforce: Subsector Occupations (2025)</h3>
            </div>

            <TableContainer component={Paper} elevation={0} className="rounded-2xl border border-gray-100 overflow-hidden">
                <Table>
                    <TableHead>
                        <TableRow style={{ backgroundColor: "#f9fafb" }}>
                            <TableCell style={{ color: "#4b5563", fontWeight: 700, fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Occupation</TableCell>
                            <TableCell style={{ color: "#4b5563", fontWeight: 700, fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Jobs</TableCell>
                            <TableCell style={{ color: "#4b5563", fontWeight: 700, fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Avg. Wage</TableCell>
                            <TableCell style={{ color: "#4b5563", fontWeight: 700, fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>YoY Wage Growth</TableCell>
                            <TableCell style={{ color: "#4b5563", fontWeight: 700, fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Openings</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((row, index) => (
                            <TableRow
                                key={index}
                                sx={{
                                    '&:last-child td, &:last-child th': { border: 0 },
                                    '&:hover': { backgroundColor: '#ecfdf5' },
                                    transition: 'background-color 0.2s'
                                }}
                            >
                                <TableCell style={{ fontWeight: 600, color: '#111827' }}>{row.occupation}</TableCell>
                                <TableCell style={{ color: '#4b5563' }}>{row.jobs.toLocaleString()}</TableCell>
                                <TableCell style={{ color: '#059669', fontWeight: 600 }}>${row.avg_wage.toLocaleString()}</TableCell>
                                <TableCell style={{ color: '#4b5563' }}>
                                    <div className="d-flex align-items-center gap-1">
                                        <TrendingUp size={12} className="text-emerald-500" />
                                        {(row.yoy_wage * 100).toFixed(1)}%
                                    </div>
                                </TableCell>
                                <TableCell>
                                    <span className="bg-emerald-50 text-emerald-700 px-2 py-1 rounded-full text-[10px] font-bold">
                                        {row.openings} vacancies
                                    </span>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </motion.div>
    );
};

export default OccupationsTable;
